var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-container"},[_c('div',[_c('b-modal',{ref:"signUpModalRef",staticClass:"text-left",attrs:{"id":"auth-form","hide-footer":""}},[_vm._t("content")],2)],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cc4ced6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/formModal/FormModalShell.vue
// module id = pxem
// module chunks = 0